import { useFindingSidebarTranslations } from '../../findingSidebar/constants';
import type { FindingObject, UserAnnotation } from '../../types';

import { ValidationButton } from './ValidationButton';

interface Props {
  annotation: UserAnnotation;
  disabled?: boolean;
  onDelete: (finding: UserAnnotation) => void;
  onMouseLeave: (finding: FindingObject | UserAnnotation) => void;
  onMouseEnter: (finding: FindingObject | UserAnnotation) => void;
}

export const ValidationAnnotation = ({
  annotation,
  disabled,
  onDelete,
  onMouseLeave,
  onMouseEnter,
}: Props) => {
  const { typeToHeaderMap } = useFindingSidebarTranslations();

  return (
    <div
      className="vai-mb-2"
      onFocus={() => onMouseEnter(annotation)}
      onMouseEnter={() => onMouseEnter(annotation)}
      onMouseLeave={() => onMouseLeave(annotation)}
    >
      <p className="vai-text-white vai-font-inter vai-text-sm vai-font-medium vai-mb-2">
        {typeToHeaderMap[annotation.type as keyof typeof typeToHeaderMap]}
      </p>
      <ValidationButton
        disabled={disabled}
        onClick={() => onDelete(annotation)}
        value="Delete"
      />
      <hr className="vai-border-background-muted vai-mt-2" />
    </div>
  );
};
